import { lazy } from 'react';
import { Routes } from './utils/renderRoutes';

const specialSaleRoutes: Routes[] = [
    {
        title: '特卖入场',
        path: '/special-sale',
        component: lazy(() => import('@/views/SpecialSale')),
    },
];
export default specialSaleRoutes;